import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/info-icon.svg'


const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "info-content" }
const _hoisted_3 = { class: "info-content-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "info-content-icon",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.props.text), 1)
    ])
  ]))
}